import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-x-circle-icon',
  template: `
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_31983_11436)">
        <path
          d="M9.99848 2.2207C5.69737 2.2207 2.2207 5.69737 2.2207 9.99848C2.2207 14.2996 5.69737 17.7763 9.99848 17.7763C14.2996 17.7763 17.7763 14.2996 17.7763 9.99848C17.7763 5.69737 14.2996 2.2207 9.99848 2.2207ZM9.99848 16.2207C6.56848 16.2207 3.77626 13.4285 3.77626 9.99848C3.77626 6.56848 6.56848 3.77626 9.99848 3.77626C13.4285 3.77626 16.2207 6.56848 16.2207 9.99848C16.2207 13.4285 13.4285 16.2207 9.99848 16.2207ZM12.7907 6.10959L9.99848 8.90181L7.20626 6.10959L6.10959 7.20626L8.90181 9.99848L6.10959 12.7907L7.20626 13.8874L9.99848 11.0951L12.7907 13.8874L13.8874 12.7907L11.0951 9.99848L13.8874 7.20626L12.7907 6.10959Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_31983_11436">
          <rect
            width="18.6667"
            height="18.6667"
            fill="currentColor"
            transform="translate(0.666016 0.666016)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XCircleIconComponent {}
